export function formatPaintingDimensionsCm(length, width) {
  const l = String(length ?? '').trim();
  const w = String(width ?? '').trim();
  if (!l || !w) return '';
  return `${l} × ${w} cm`;
}

export function paintingDimensionsError(length, width) {
  const l = Number(length);
  const w = Number(width);
  if (!String(length ?? '').trim() || !String(width ?? '').trim()) {
    return 'Enter the painting length and width in cm.';
  }
  if (!Number.isFinite(l) || !Number.isFinite(w) || l <= 0 || w <= 0) {
    return 'Length and width must be greater than 0.';
  }
  if (l > 500 || w > 500) {
    return 'Dimensions must be 500 cm or less.';
  }
  return '';
}

export function looksLikePaintingDimensions(value) {
  return /\d+(?:\.\d+)?\s*[×x]\s*\d+(?:\.\d+)?\s*cm/i.test(String(value || ''));
}
